import { useReveal } from "@/hooks/use-reveal";

function Reveal({ children, className = "", ...props }) {
  const [ref, visible] = useReveal();
  return <div ref={ref} {...props} className={`reveal ${visible ? "is-visible" : ""} ${className}`}>{children}</div>;
}

export default Reveal;
